import { DescriptionText } from '../styles'

import { NormalizedWrapper } from '@theme'

import { config } from './config'
import { Wrapper } from './styles'

const { description } = config

export function Description() {
  return (
    <NormalizedWrapper>
      <Wrapper>
        <DescriptionText>{description}</DescriptionText>
      </Wrapper>
    </NormalizedWrapper>
  )
}
